import { useRef, useState } from 'react';
import { CheckboxWithLabel } from '@wg/wows-react-uikit';
import classNames from 'classnames';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { changeGlobalFilters } from '~/Actions/ActionFilter';
import globalFiltersMap from '~/Components/AdditionalFilter/globalFiltersMap';
import { playDropdownClickSound } from '~/helpers/audioApi';
import { DWH_EVENTS } from '~/helpers/consts';
import dwhExport from '~/helpers/dwhExport';
import useClickAway from '~/hooks/useClickAway';
import { ICategories } from '~/interfaces';
import { State } from '~/Reducers';
import { IGlobalFilters } from '~/Reducers/ReducerFilter';

import styles from './AdditionalFilter.scss';

interface IProps {
    category: ICategories;
}

interface IState {
    globalFilters: IGlobalFilters;
}

const stateSelector = (state: State): IState => {
    return {
        globalFilters: state.ReducerFilter.globalFilters,
    };
};

const AdditionalFilter = (props: IProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const filterGlobalState = useSelector<State, IState>(stateSelector, shallowEqual);

    const [state, setState] = useState<{ isVisible: boolean }>({ isVisible: false });

    const renderContent = () => {
        return (
            <div className={styles.filterContainer}>
                <div className={classNames(styles.filterColumn, styles.filterColumnBorder)}>
                    <div className={styles.filterColumnBody}>
                        {globalFiltersMap.map((filterItem) => {
                            const value = filterGlobalState.globalFilters[filterItem.name];
                            return (
                                <div className={styles.filterItem} key={filterItem.name}>
                                    <CheckboxWithLabel
                                        isChecked={value}
                                        onChange={() => {
                                            dwhExport.send(DWH_EVENTS.APPLY_FILTERS, { category: props.category, name: filterItem.name, value: !value ? 'on' : 'off' });
                                            dispatch(changeGlobalFilters(props.category, filterItem.name, !value));
                                        }}
                                        labelText={filterItem.title}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const changeVisible = () => {
        setState({
            isVisible: !state.isVisible,
        });
    };

    const classNamesIcon = classNames(styles.filterIcon, {
        [styles.active]: state.isVisible,
    });

    useClickAway(ref, () => {
        setState({ isVisible: false });
    });

    return (
        <div className={styles.filterContent} ref={ref}>
            <div
                className={classNamesIcon}
                onClick={() => {
                    playDropdownClickSound();
                    changeVisible();
                }}
            />
            {state.isVisible && renderContent()}
        </div>
    );
};

export default AdditionalFilter;
